import React from 'react';

export default function IncreaseIcon({ currentColor = '#D7D7D7' }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="5.5" transform="matrix(1 0 0 -1 2 14)" stroke={currentColor} />
      <path d="M6 8H10" stroke={currentColor} strokeLinecap="square" />
      <path d="M8 10L8 6" stroke={currentColor} strokeLinecap="square" />
      <path d="M12 12L13.5 13.5" stroke={currentColor} strokeLinecap="round" />
    </svg>
  );
}
